// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"730eeb30038ba205837c","777":"e1704e3e94d15985c01e"}[chunkId] + ".js";
};